import { TimeHelper } from "../../helpers/TimeHelper";

class OrganisationLureModel {
  orgLureId;
  isTrial;
  lureId;
  lureDueDate;
  lureShipDate;
  pestType;
  productCode;
  productName;
  quantity;
  comments;

  constructor(data) {
    this.populate(data || {
      isTrial: false,
      quantity: 0
    });
  }


  populate(data) {
    this.orgLureId = data.orgLureId;
    this.isTrial = data.isTrial;
    this.lureId = data.lureId;
    this.lureDueDate = data.lureDueDate || null;
    this.lureShipDate = data.lureShipDate || null;
    this.pestType = data.pestType;
    this.productCode = data.productCode;
    this.productName = data.productName;
    this.quantity = data.quantity;
    this.comments = data.comments;
  }

  toJson() {
    const output = {};
    output.orgLureId = this.orgLureId;
    output.isTrial = this.isTrial;
    output.lureId = this.lureId;
    output.lureDueDate = this.lureDueDate || null;
    output.lureShipDate = this.lureShipDate || null;
    output.pestType = this.pestType;
    output.productCode = this.productCode;
    output.productName = this.productName;
    output.quantity = this.quantity;
    output.comments = this.comments;
    
    return output;
  }
}

export { OrganisationLureModel };